import { Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { DropdownSelect } from "components/DropdownSelect";
import { ContainerHeader } from "components/Ibox/style";
import { PrimaryButton } from "components/Button/style";
import { FaFilter, FaPrint } from "react-icons/fa";
import { CustomInput } from "components/CustomInput";
import { CustomInputModal } from "components/CustomInputModal";
import { MaisFiltros } from "components/ButtonModal";
import {
  Button,
  ButtonsContainer,
  Container,
  FormContainer,
  InputContainer,
  InputContainerMaisFiltros,
  MaisFiltrosContainer,
  Title,
} from "./style";
import { FiltrosImpressao } from "../../hooks/useImpressaoEtiqueta";

const statusOptions = [
  { value: "PENDENTE", label: "Pendente" },
  { value: "IMPRIMINDO", label: "Imprimindo" },
  { value: "IMPRESSO", label: "Impresso" },
  { value: "ERRO", label: "Erro" },
];

const ordenarPorOptions = [
  { value: "placa", label: "Placa" },
  { value: "criadoEm", label: "Data" },
];

const ordenacaoOptions = [
  { value: "DESC", label: "Decrescente" },
  { value: "ASC", label: "Crescente" },
];

const defaultValues: FiltrosImpressao = {
  placa: [],
  idProcesso: [],
  identificadorMaquina: "",
  status: "PENDENTE",
  ordenarPor: "placa",
  ordenacao: "DESC",
  dataInicio: "",
  dataFim: "",
};

interface IFiltrosProps {
  onFiltrar: (filtros: FiltrosImpressao) => void;
  onImprimirTodos: () => void;
  imprimindoTodos: boolean;
  impressoraConectada: boolean;
  qtdParaImprimir: number;
}

export function Filtros({
  onFiltrar,
  onImprimirTodos,
  imprimindoTodos,
  impressoraConectada,
  qtdParaImprimir,
}: IFiltrosProps) {
  const { handleSubmit, reset, control, setValue } = useForm<FiltrosImpressao>({ defaultValues });

  function localParaUtcIso(valor: string): string {
    if (!valor) return "";
    return new Date(valor).toISOString();
  }

  function handleSubmitFiltros(dados: FiltrosImpressao) {
    onFiltrar({
      ...dados,
      status: dados.status || "",
      ordenarPor: dados.ordenarPor || "placa",
      ordenacao: dados.ordenacao || "DESC",
      dataInicio: localParaUtcIso(dados.dataInicio),
      dataFim: localParaUtcIso(dados.dataFim),
    });
  }

  function handleLimpar() {
    reset(defaultValues);
  }

  function handleLimparMaisFiltros() {
    setValue("dataInicio", "");
    setValue("dataFim", "");
    setValue("ordenarPor", "placa");
    setValue("ordenacao", "DESC");
  }

  return (
    <Container>
      <ContainerHeader>
        <Title>Filtros</Title>
        <PrimaryButton
          buttonWidth="xl"
          buttonWidthTipo="px"
          onClick={onImprimirTodos}
          disabled={!impressoraConectada || imprimindoTodos || qtdParaImprimir === 0}
        >
          {imprimindoTodos ? "Imprimindo..." : `Imprimir Todos${qtdParaImprimir > 0 ? ` (${qtdParaImprimir})` : ""}`}
          <FaPrint style={{ fontSize: "12px", marginBottom: "3px", marginLeft: "6px" }} />
        </PrimaryButton>
      </ContainerHeader>
      <hr />
      <FormContainer>
        <Form noValidate onSubmit={handleSubmit(handleSubmitFiltros)}>
          <Row className="mb-4">
            <InputContainer>
              <Form.Group>
                <Form.Label>Placas</Form.Label>
                <Controller
                  control={control}
                  name="placa"
                  defaultValue={[]}
                  render={({ field: { onChange, value } }) => (
                    <CustomInputModal
                      label="Filtrar em massa"
                      value={value ?? []}
                      placeholder="Busque por placa"
                      onConfirm={onChange}
                      validar={false}
                      style={{ width: "100%" }}
                      placeholderModal="Digite ou cole as placas e tecle ENTER"
                      labelItem="Placa"
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>

            <InputContainer>
              <Form.Group>
                <Form.Label>Processos</Form.Label>
                <Controller
                  control={control}
                  name="idProcesso"
                  defaultValue={[]}
                  render={({ field: { onChange, value } }) => (
                    <CustomInputModal
                      label="Filtrar em massa"
                      value={value ?? []}
                      placeholder="Busque por processo"
                      onConfirm={onChange}
                      validar={false}
                      style={{ width: "100%" }}
                      placeholderModal="Digite ou cole os IDs dos processos e tecle ENTER"
                      labelItem="ID Processo"
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>

            <InputContainer>
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Controller
                  control={control}
                  name="status"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      options={statusOptions}
                      title=""
                      selectedValue={value}
                      onSelect={onChange}
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>

            <InputContainer>
              <Form.Group>
                <Form.Label>Identificador Máquina</Form.Label>
                <Controller
                  control={control}
                  name="identificadorMaquina"
                  render={({ field: { onChange, value } }) => (
                    <CustomInput
                      type="text"
                      placeholder="Ex: MAQUINA_01"
                      style={{ height: "2.2rem" }}
                      onChange={onChange}
                      value={value ?? ""}
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>

            <InputContainer>
              <Form.Group>
                <ButtonsContainer>
                  <Button type="submit">
                    <FaFilter style={{ fontSize: "12px", marginBottom: "3px", marginRight: "5px" }} />
                    Buscar
                  </Button>
                  <Button type="button" outline variante="primary" onClick={handleLimpar}>
                    Limpar
                  </Button>
                </ButtonsContainer>
              </Form.Group>
            </InputContainer>

            <InputContainer>
              <MaisFiltrosContainer>
                <MaisFiltros
                  limparTudoOnClick={handleLimparMaisFiltros}
                  cancelarOnClick={handleLimparMaisFiltros}
                  widthModal="lg"
                  showMaisFiltrosDefault={false}
                  handleClickAplicarFiltros={() => {}}
                  submit
                >
                  <InputContainerMaisFiltros>
                    <Form.Group>
                      <Form.Label>Data início</Form.Label>
                      <Controller
                        control={control}
                        name="dataInicio"
                        render={({ field: { onChange, value } }) => (
                          <Form.Control
                            type="datetime-local"
                            onChange={onChange}
                            value={value ?? ""}
                            style={{ height: "2.2rem", borderRadius: "8px" }}
                          />
                        )}
                      />
                    </Form.Group>
                  </InputContainerMaisFiltros>

                  <InputContainerMaisFiltros>
                    <Form.Group>
                      <Form.Label>Data fim</Form.Label>
                      <Controller
                        control={control}
                        name="dataFim"
                        render={({ field: { onChange, value } }) => (
                          <Form.Control
                            type="datetime-local"
                            onChange={onChange}
                            value={value ?? ""}
                            style={{ height: "2.2rem", borderRadius: "8px" }}
                          />
                        )}
                      />
                    </Form.Group>
                  </InputContainerMaisFiltros>

                  <InputContainerMaisFiltros>
                    <Form.Group>
                      <Form.Label>Ordenar por</Form.Label>
                      <Controller
                        control={control}
                        name="ordenarPor"
                        render={({ field: { onChange, value } }) => (
                          <DropdownSelect
                            options={ordenarPorOptions}
                            title=""
                            selectedValue={value}
                            onSelect={onChange}
                          />
                        )}
                      />
                    </Form.Group>
                  </InputContainerMaisFiltros>

                  <InputContainerMaisFiltros>
                    <Form.Group>
                      <Form.Label>Direção</Form.Label>
                      <Controller
                        control={control}
                        name="ordenacao"
                        render={({ field: { onChange, value } }) => (
                          <DropdownSelect
                            options={ordenacaoOptions}
                            title=""
                            selectedValue={value}
                            onSelect={onChange}
                          />
                        )}
                      />
                    </Form.Group>
                  </InputContainerMaisFiltros>
                </MaisFiltros>
              </MaisFiltrosContainer>
            </InputContainer>
          </Row>
        </Form>
      </FormContainer>
    </Container>
  );
}
